import React, { useEffect, useState } from 'react';
import { Modal, Row, Col, Card, Button, Dropdown } from 'react-bootstrap';
import Glide from 'components/carousel/Glide';
import { useDispatch, useSelector } from 'react-redux';
import CsLineIcons from 'cs-line-icons/CsLineIcons';
import classNames from 'classnames';
import SearchHeaderBar from 'views/search/components/SearchHeaderBar';
import MainMenu from './main-menu/MainMenu';
import { NavLink, Link } from 'react-router-dom';
import SidebarMenu from './sidebar-menu/SidebarMenu';
import NavIconMenu from './NavIconMenu';
import ContestantQuickViewTab from 'views/users/contestants/components/ContestantQuickViewTab';
import SearchInput from './search/SearchInput';
import { GetUserStore } from 'SessionState/User/UserStore';
import { GetEventStore } from 'SessionState/Event/EventStore';
import { BetaWrapper, ProMemberWrapper } from 'views/default/BetaWrapper';
import { useHistory } from 'react-router-dom';
import EventCard from 'views/events/components/EventCard';
import EventIconCard from 'views/events/components/EventIconCard';
import UserQuickViewTab from 'views/users/components/UserQuickViewTab';
import { GetContestantStore } from 'SessionState/Contestant/ContestantStore';
import { ContestantUserModel } from 'API/Generated/data-contracts';
import { ContestantUserBaseModel } from 'API/Generated/data-contracts';
import { IReduxState } from 'ReduxState';
import AddEditContestantModal from 'views/modals/AddEditContestantModal';
import AddEditBusinessModal from 'views/business/components/AddEditBusinessModal';
import ImageRender from 'views/components/ImageRender';
import ContestantIconCard from 'views/users/contestants/components/ContestantIconCard';
import PreferencesModal from 'layout/right-buttons/PreferencesModal';
interface Props {
  contestantUserModel: ContestantUserModel | undefined;
}

// Utility function to delete cookies
function deleteCookie(name: string): void {
  document.cookie = name + "=; Max-Age=-99999999; path=/;";
}

const UserOptionsModal = ({ show, setShow, toggle }, props: { contestantUser: ContestantUserBaseModel }) => {
  const userStore = GetUserStore();
  const eventStore = GetEventStore();
  const history = useHistory();
  const contestantStore = GetContestantStore();
  const containerName = 'profile-pics';
  const [addContestantModal, setAddContestantModal] = useState(false);
  const [addEditBusinessModal, setAddEditBusinessModal] = useState(false);
  const [addBusinessModal, setAddBusinessModal] = useState(false);
  const [isShowSettingsModal, setIsShowSettingsModal] = useState(false);
  const showSettingsModal = () => {
    setIsShowSettingsModal(true);
  };
  const closeSettingsModal = () => {
    setIsShowSettingsModal(false);
    document.documentElement.click();
  };

  const onToggle = (status, event) => {
    if (event && event.stopPropagation) event.stopPropagation();
    else if (event && event.originalEvent && event.originalEvent.stopPropagation) event.originalEvent.stopPropagation();

  };

  const handleLogout = () => {
    deleteCookie("authToken");
    userStore.logout();
    history.push('/login');
  };

  const navigateToContestantUserProfile = () => {
    // contestantStore.resetCurrentUser();
    if (props.contestantUser?.id) {
      contestantStore.getContestant(props.contestantUser.id);
      history.push(`/contestant/profile`);
    }
  }

  const [isShowPreferencesModal, setIsShowPreferencesModal] = useState(false);
  const showPreferencesModal = () => {
    setIsShowPreferencesModal(true);
  };
  const closePreferencesModal = () => {
    setIsShowPreferencesModal(false);
    document.documentElement.click();
  };


  const { navClasses, placementStatus, behaviourStatus, attrMobile, menuPadding } = useSelector((state: IReduxState) => state.menu);
  // const mouseActionTimer = useRef(null);
  return (

    <Modal id="userOptionsModal" className="modal-under-nav modal-close-out modal-right large" size="lg" show={show} onHide={() => setShow(false)} onClick={toggle} onToggle={onToggle}>
      <Modal.Body className="ps-5 pe-5 pb-0 border-0 bg-background">
        {/* <Row>
          <Col>
          <NavIconMenu />
          </Col>
        <Col>
<Dropdown>
            <Dropdown.Toggle className="btn-icon btn-icon-only dropdown-toggle-no-arrow" variant="foreground">
            <CsLineIcons icon="at-sign" className="me-2" size="17" /> <span className="align-middle">Contact Us</span>
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Row className='m-2'>
                <Col>
                <Button variant="outline-info" className="btn-icon btn-icon-only mb-1" href="https://www.facebook.com/hellotiaraco/" target='_blank'>
                  <CsLineIcons icon="facebook" />
                </Button>{' '}
                </Col>
                <Col>
                <Button variant="outline-primary" className="btn-icon btn-icon-only mb-1" href={`mailto:support@hellotiara.com?Subject=Hello%20Tiara%20User%20${userStore.CurrentUser?.firstName}%20${userStore.CurrentUser?.lastName}%20is%20trying%20to%20reach%20you.`}>
                  <CsLineIcons icon="email" />
                </Button>{' '}
                </Col>
              </Row>
            </Dropdown.Menu>
          </Dropdown>
        </Col>
        <Col>
        <Button variant="outline-primary" className="btn-icon m-1">
        <a href="/contact">
              <CsLineIcons icon="send" className="me-2" size="17" /> <span className="align-middle">Contact Us</span>
            </a>
        </Button>
                <Button variant="outline-info" className="btn-icon btn-icon-only m-1" href="https://www.facebook.com/hellotiaraco/" target='_blank'>
                  <CsLineIcons icon="facebook" />
                </Button>{' '}
                </Col>
        </Row> */}
        <Row className='row-cols-1 row-cols-md-2 mb-5 g-2' onClick={() => setShow(false)}>
          
          {/* To Profile start */}
          <Col>
            <NavLink to="/profile">
              <Card>
                <Row className="g-0 sh-9 p-card pt-0 pb-0 mb-2">

                  <Col xs="2" className="d-flex align-items-center justify-content-center">
                    <div className="pe-card">
                    <ImageRender src={userStore.CurrentUser?.profilePic?.image } containerName={containerName}   alt={userStore.CurrentUser?.firstName  || 'Profile Button'} className="profile rounded-circle sh-8 sw-8 p-2" /> 
                    </div>
                  </Col>
                  <Col xs="10" className="d-flex flex-column justify-content-center">
                    <p className="heading mb-0">{userStore.CurrentUser?.firstName} {userStore.CurrentUser?.lastName} Profile</p>
                  </Col>
                </Row>
              </Card>
            </NavLink>
          </Col>
          {/* To Profile end */}

          {/* To Dashboard start */}
          <ProMemberWrapper>
          <Col>
            <NavLink to="/dashboard">
              <Card>
                <Row className="g-0 sh-9 p-card pt-0 pb-0 mb-2">
                  <Col xs="2" className="d-flex align-items-center justify-content-center">
                    <div className="pe-card">
                      <CsLineIcons icon="dashboard-1" className="text-primary" />
                    </div>
                  </Col>
                  <Col xs="10" className="d-flex flex-column justify-content-center">
                    <p className="heading mb-0">Professional Dashboard</p>
                  </Col>
                </Row>
              </Card>
            </NavLink>
          </Col>
          </ProMemberWrapper>
          {/* To Dashboard end */}
        </Row>
        {/* Shortcuts start */}
        <Row className='mb-5'>
          <Row className='p-0 text-center' >
            <Glide
              noControls
              options={{
                gap: 0,
                rewind: true,
                bound: true,
              peek: 0.5,
                perView: 4,
                breakpoints: {
                  400: { perView: 4.25 },
                  600: { perView: 4.25 },
                  1000: { perView: 4.25 },
                  1400: { perView: 6.25 },
                  1600: { perView: 6.25 },
                  1900: { perView: 6.25 },
                  3840: { perView: 6.25 },
                },
              }}
            >
            
               {eventStore.FutureEventList.length > 0 && eventStore.FutureEventList.map((event, index) => (
    <Glide.Item key={index}>
      <Col onClick={() => setShow(false)}>
        <EventIconCard eventModel={event} />
      </Col>
    </Glide.Item>
  ))}
            </Glide>
          </Row>
        </Row>
        {/* Shortcuts end */}

        {/* <Row className='mb-3'>
        <SearchInput show={show} setShow={setShow} />
        </Row> */}
        <Row className='row-cols-1 row-cols-md-2 mb-5'>
          {/* Explore start */}
          <Col>
            <div className='mb-5'>
              <Col xs="12" className="ps-1 mb-2 mt-2">
                <div className="text-extra-small text-body">EXPLORE</div>
              </Col>
              <Row className='row-cols-2'>
                {/* Search Events start */}
                <Col>
                <Card className="mb-2"  onClick={() => setShow(false)}>
                  <a href="/events/home">
                    <Row className="g-0 sh-9 p-card p-1">
                      <Col className="d-flex align-items-center justify-content-center col-auto p-2">
                        <div className="d-flex rounded-xl bg-pink sw-4 sh-4 mb-1 justify-content-center align-items-center">
                        <i className="d-inline-block icon-20 bi-calendar3" />
                          </div>
                      </Col>
                      <Col className="d-flex flex-column justify-content-center col">
                        <p className="heading mb-0 text-body pl-1">Upcoming Events</p>
                      </Col>
                    </Row>
                  </a>
                </Card>
                </Col>
                {/* Search Events end */}
                    {/* Past Events start */}
                <Col>
                <Card className="mb-2"  onClick={() => setShow(false)}>
                  <a href="/events/past">
                    <Row className="g-0 sh-9 p-card p-1">
                      <Col className="d-flex align-items-center justify-content-center col-auto p-2">
                        <div className="d-flex rounded-xl bg-danger sw-4 sh-4 mb-1 justify-content-center align-items-center">
                        <CsLineIcons icon="prize" className='text-white'/>
                          </div>
                      </Col>
                      <Col className="d-flex flex-column justify-content-center col">
                        <p className="heading mb-0 text-body pl-1">Past Events</p>
                      </Col>
                    </Row>
                  </a>
                </Card>
              </Col>
                    {/* Past Events end */}

                  {/* Search Businesses start */}
                  <Col>
                <Card className="mb-2"  onClick={() => setShow(false)}>
                  <a href="/business/home">
                    <Row className="g-0 sh-9 p-card p-1">
                      <Col className="d-flex align-items-center justify-content-center col-auto p-2">
                        <div className="d-flex rounded-xl bg-success sw-4 sh-4 mb-1 justify-content-center align-items-center">
                        <CsLineIcons icon="crown" className='text-white'/>
                          </div>
                      </Col>
                      <Col className="d-flex flex-column justify-content-center col">
                        <p className="heading mb-0 text-body pl-1">Pageant Systems</p>
                      </Col>
                    </Row>
                  </a>
                </Card>
              </Col>
                {/* Search Businesses end */}
                       {/* Search Directors start */}
                       <Col>
                <Card className="mb-2"  onClick={() => setShow(false)}>
                  <a href="/members/home">
                    <Row className="g-0 sh-9 p-card p-1">
                      <Col className="d-flex align-items-center justify-content-center col-auto p-2">
                        <div className="d-flex rounded-xl bg-info sw-4 sh-4 mb-1 justify-content-center align-items-center">
                        <i className="d-inline-block icon-20 bi-person-square" />
                          </div>
                      </Col>
                      <Col className="d-flex flex-column justify-content-center col">
                        <p className="heading mb-0 text-body pl-1">Directors</p>
                      </Col>
                    </Row>
                  </a>
                </Card>
              </Col>
                {/* Search Directors end */}

                {/* Search Vendors start */}
                <BetaWrapper>
                  <Col>
                    <Card className="mb-2">
                      <NavLink to="/members/home">
                        <Row className="g-0 sh-9 p-card pt-0 pb-0">
                          <Col xs="2" className="d-flex align-items-center justify-content-center">
                            <div className="pe-card">
                              <i className="d-inline-block text-primary icon-20 bi-people" />
                            </div>
                          </Col>
                          <Col xs="10" className="d-flex flex-column justify-content-center">
                            <p className="heading mb-0">Vendors</p>
                          </Col>
                        </Row>
                      </NavLink>
                    </Card>
                  </Col>
                </BetaWrapper>
                {/* Search Vendors end */}

                {/* Search Coaches start */}
                <BetaWrapper>
                  <Col>
                    <Card className="mb-2">
                      <NavLink to="/members/home">
                        <Row className="g-0 sh-9 p-card pt-0 pb-0">
                          <Col xs="2" className="d-flex align-items-center justify-content-center">
                            <div className="pe-card">
                              <i className="d-inline-block text-primary icon-20 bi-megaphone" />
                            </div>
                          </Col>
                          <Col xs="10" className="d-flex flex-column justify-content-center">
                            <p className="heading mb-0">Coaches</p>
                          </Col>
                        </Row>
                      </NavLink>
                    </Card>
                  </Col>
                </BetaWrapper>
                {/* Search Coaches end */}

                {/* Search Contestants start */}
                <BetaWrapper>
                  <Col>

                    <Card className="mb-2">

                      <Row className="g-0 sh-9 p-card pt-0 pb-0">
                        <Col xs="2" className="d-flex align-items-center justify-content-center">
                          <div className="pe-card">
                            <CsLineIcons icon="crown" className="text-primary" />
                          </div>
                        </Col>
                        <Col xs="10" className="d-flex flex-column justify-content-center">
                          <p className="heading mb-0">Contestants</p>
                        </Col>
                      </Row>

                    </Card>
                  </Col>
                </BetaWrapper>
                {/* Search Contestants end */}
              </Row>
            </div>

            {/* Shop Custom start */}
            <BetaWrapper>
              <div className='mb-5'>
                <Col xs="12" className="ps-1 me-2 mb-2">
                  <div className="text-extra-small text-body">SHOP CUSTOM</div>
                </Col>
                <Col>

                  <Card className="mb-2">
                    <NavLink to="/events/home">
                      <Row className="sh-5 g-0 p-card pt-0 pb-0">
                        <Col xs="2" className="d-flex align-items-center justify-content-center">
                          <div className="pe-card">
                            <CsLineIcons icon="scissors" className="text-primary" />
                          </div>
                        </Col>
                        <Col xs="10" className="d-flex flex-column justify-content-center">
                          <p className=" mb-0">Wardrobe</p>
                        </Col>
                      </Row>
                    </NavLink>
                  </Card>
                  <Card className="mb-2">
                    <NavLink to="/events/home">
                      <Row className="sh-5 g-0 p-card pt-0 pb-0">
                        <Col xs="2" className="d-flex align-items-center justify-content-center">
                          <div className="pe-card">
                            <CsLineIcons icon="laptop" className="text-primary" />
                          </div>
                        </Col>
                        <Col xs="10" className="d-flex flex-column justify-content-center">
                          <p className=" mb-0">Graphics/Digital/Prints</p>
                        </Col>
                      </Row>
                    </NavLink>
                  </Card>
                  <Card className="mb-2">
                    <NavLink to="/events/home">
                      <Row className="sh-5 g-0 p-card pt-0 pb-0">
                        <Col xs="2" className="d-flex align-items-center justify-content-center">
                          <div className="pe-card">
                            <CsLineIcons icon="music" className="text-primary" />
                          </div>
                        </Col>
                        <Col xs="10" className="d-flex flex-column justify-content-center">
                          <p className=" mb-0">Music Mixes</p>
                        </Col>
                      </Row>
                    </NavLink>
                  </Card>
                  <Card className="mb-2">
                    <NavLink to="/events/home">
                      <Row className="sh-5 g-0 p-card pt-0 pb-0">
                        <Col xs="2" className="d-flex align-items-center justify-content-center">
                          <div className="pe-card">
                            <CsLineIcons icon="brush" className="text-primary" />
                          </div>
                        </Col>
                        <Col xs="10" className="d-flex flex-column justify-content-center">
                          <p className=" mb-0">Props</p>
                        </Col>
                      </Row>
                    </NavLink>
                  </Card>
                  <Card className="mb-2">
                    <NavLink to="/events/home">
                      <Row className="sh-5 g-0 p-card pt-0 pb-0">
                        <Col xs="2" className="d-flex align-items-center justify-content-center">
                          <div className="pe-card">
                            <CsLineIcons icon="more-horizontal" className="text-primary" />
                          </div>
                        </Col>
                        <Col xs="10" className="d-flex flex-column justify-content-center">
                          <p className="mb-0">More</p>
                        </Col>
                      </Row>
                    </NavLink>
                  </Card>

                </Col>
              </div>
              <div className='mb-5'>
                <Col xs="12" className="ps-1 mt-2 mb-2">
                  <div className="text-extra-small text-body">BOOK</div>
                </Col>
                <Col>
                  <Card className="mb-2">
                    <NavLink to="/events/home">
                      <Row className="sh-5 g-0 p-card pt-0 pb-0">
                        <Col xs="2" className="d-flex align-items-center justify-content-center">
                          <div className="pe-card">
                            <CsLineIcons icon="brush-2" className="text-primary" />
                          </div>
                        </Col>
                        <Col xs="10" className="d-flex flex-column justify-content-center">
                          <p className=" mb-0">Hair and Makeup</p>
                        </Col>
                      </Row>
                    </NavLink>
                  </Card>
                  <Card className="mb-2">
                    <NavLink to="/events/home">
                      <Row className="sh-5 g-0 p-card pt-0 pb-0">
                        <Col xs="2" className="d-flex align-items-center justify-content-center">
                          <div className="pe-card">
                            <CsLineIcons icon="camera" className="text-primary" />
                          </div>
                        </Col>
                        <Col xs="10" className="d-flex flex-column justify-content-center">
                          <p className=" mb-0">Photography</p>
                        </Col>
                      </Row>
                    </NavLink>
                  </Card>
                  <Card className="mb-2">
                    <NavLink to="/events/home">
                      <Row className="sh-5 g-0 p-card pt-0 pb-0">
                        <Col xs="2" className="d-flex align-items-center justify-content-center">
                          <div className="pe-card">
                            <CsLineIcons icon="tent" className="text-primary" />
                          </div>
                        </Col>
                        <Col xs="10" className="d-flex flex-column justify-content-center">
                          <p className=" mb-0">Tanning</p>
                        </Col>
                      </Row>
                    </NavLink>
                  </Card>
                  <Card className="mb-2">
                    <NavLink to="/events/home">
                      <Row className="sh-5 g-0 p-card pt-0 pb-0">
                        <Col xs="2" className="d-flex align-items-center justify-content-center">
                          <div className="pe-card">
                            <CsLineIcons icon="cupcake" className="text-primary" />
                          </div>
                        </Col>
                        <Col xs="10" className="d-flex flex-column justify-content-center">
                          <p className="mb-0">Alterations</p>
                        </Col>
                      </Row>
                    </NavLink>
                  </Card>
                  <Card className="mb-2">
                    <NavLink to="/events/home">
                      <Row className="sh-5 g-0 p-card pt-0 pb-0">
                        <Col xs="2" className="d-flex align-items-center justify-content-center">
                          <div className="pe-card">
                            <CsLineIcons icon="more-horizontal" className="text-primary" />
                          </div>
                        </Col>
                        <Col xs="10" className="d-flex flex-column justify-content-center">
                          <p className="mb-0">More...</p>
                        </Col>
                      </Row>
                    </NavLink>
                  </Card>

                </Col>
              </div>
            </BetaWrapper>
            {/* Shop Custom end */}

          </Col>
          <Col>
            {/* Explore end */}

            {/* My COntestants start */}
            <div className='mb-5'>
            <Col xs="12" className="ps-1 mb-2 mt-2">
                <div className="text-extra-small text-body">MY CONTESTANTS</div>
              </Col>
              <Row className='mb-5'>
          <Row className='p-0 text-center' >
            <Glide
              noControls
              options={{
                gap: 0,
                rewind: true,
                bound: true,
              peek: 0.5,
                perView: 4,
                breakpoints: {
                  400: { perView: 4.25 },
                  600: { perView: 4.25 },
                  1000: { perView: 4.25 },
                  1400: { perView: 4.25 },
                  1600: { perView: 4.25 },
                  1900: { perView: 4.25 },
                  3840: { perView: 4.25 },
                },
              }}
            >
            
            {userStore.CurrentUser.contestantUserAccounts?.map(contestant => (
    <Glide.Item key={contestant.id}>
      <Col onClick={() => setShow(false)}>
        <ContestantIconCard contestantUser={contestant} />
      </Col>
    </Glide.Item>
  ))}
            </Glide>
          </Row>
        </Row>
            </div>
            {/* My COntestants end */}

            {/* Resources start */}
            <BetaWrapper>
              <div className='mb-5'>
                <Col xs="12" className="ps-1 mb-2">
                  <div className="text-extra-small text-body">RESOURCES</div>
                </Col>
                <Col>
                  <Card className="mb-1">
                    <a href="/resources/dashboard">
                      <Row className="g-0 sh-9 p-card pt-0 pb-0">
                        <Col xs="2" className="d-flex align-items-center justify-content-center">
                          <div className="pe-card">
                            <CsLineIcons icon="diploma" className="text-primary" />
                          </div>
                        </Col>
                        <Col xs="10" className="d-flex flex-column justify-content-center">
                          <p className="heading mb-0">New To Pageants</p>
                          <p className="text-small text-muted mb-0">Tips and tricks for all things pageantry</p>
                        </Col>
                      </Row>
                    </a>
                  </Card>
                </Col>
                <Col>
                  <Card className="mb-1">
                    <a href="/resources/faq">
                      <Row className="g-0 sh-9 p-card pt-0 pb-0">
                        <Col xs="2" className="d-flex align-items-center justify-content-center">
                          <div className="pe-card">
                            <CsLineIcons icon="question-hexagon" className="text-primary" />
                          </div>
                        </Col>
                        <Col xs="10" className="d-flex flex-column justify-content-center">
                          <p className="heading mb-0">FAQ</p>
                          <p className="text-small text-muted mb-0">Ask questions and get answers by trusted professionals</p>
                        </Col>
                      </Row>
                    </a>
                  </Card>
                </Col>
              </div>
            </BetaWrapper>
            {/* Resources end */}

          

        
          
          </Col>
          <Col>
  {/* Quick Add start */}
  <div className='mb-5'>
              <Col xs="12" className="ps-1 mb-2">
                <div className="text-extra-small text-body">QUICK ADD</div>
              </Col>
              <Row className='row-cols-2' >
                {/* Add new event start */}
                <ProMemberWrapper>
                <Col>
                  <NavLink to="/events/add" onClick={() => setShow(false)}>
                    <Row className="g-0 sh-9 p-card pt-0 pb-0">
                      <Col xs="2" className="d-flex align-items-center justify-content-center">
                        <div className="pe-card">
                          <CsLineIcons icon="plus" className="text-primary" />
                        </div>
                      </Col>
                      <Col xs="10" className="d-flex flex-column justify-content-center">
                        <p className="text-small mb-0">Add Pageant</p>
                      </Col>
                    </Row>
                  </NavLink>
                </Col>
                <Col>
                <div onClick={() => setAddBusinessModal(true)} className='cursor-pointer'>
                    <Row className="g-0 sh-9 p-card pt-0 pb-0">
                      <Col xs="2" className="d-flex align-items-center justify-content-center">
                        <div className="pe-card">
                          <CsLineIcons icon="plus" className="text-primary" />
                        </div>
                      </Col>
                      <Col xs="10" className="d-flex flex-column justify-content-center" >
                        <p className="text-small mb-0">Add New Business</p>
                      </Col>
                    </Row>
                  </div>
                </Col>
                <AddEditBusinessModal addEditBusinessModal={addBusinessModal} setAddEditBusinessModal={setAddBusinessModal} business={undefined} />
                </ProMemberWrapper>
                {/* Add new event end */}
                {/* Add new contestant member start */}
                <Col>
                  <div onClick={() => setAddContestantModal(true)} className='cursor-pointer'>
                    <Row className="g-0 sh-9 p-card pt-0 pb-0">
                      <Col xs="2" className="d-flex align-items-center justify-content-center">
                        <div className="pe-card">
                          <CsLineIcons icon="plus" className="text-primary" />
                        </div>
                      </Col>
                      <Col xs="10" className="d-flex flex-column justify-content-center" >
                        <p className="text-small mb-0">Add New Contestant</p>
                      </Col>
                    </Row>
                  </div>
                </Col>
                {/* Add new contestant member end */}
                <AddEditContestantModal addEditContestantModal={addContestantModal} setAddEditContestantModal={setAddContestantModal} contestant={undefined} />
                <BetaWrapper>
                  {/* Add products and services start */}
                  <Col>
                    <Row className="g-0 sh-9 p-card pt-0 pb-0">
                      <Col xs="2" className="d-flex align-items-center justify-content-center">
                        <div className="pe-card">
                          <CsLineIcons icon="plus" className="text-primary" />
                        </div>
                      </Col>
                      <Col xs="10" className="d-flex flex-column justify-content-center">
                        <p className="text-small mb-0">Add Products & Services</p>
                      </Col>
                    </Row>
                  </Col>
                  {/* Add products and services end */}

                  {/* Add businesses start */}
                  <Col>
                    <Card className="mb-1">
                      <Row className="g-0 sh-9 p-card pt-0 pb-0">
                        <Col xs="2" className="d-flex align-items-center justify-content-center">
                          <div className="pe-card">
                            <CsLineIcons icon="plus" className="text-primary" />
                          </div>
                        </Col>
                        <Col xs="10" className="d-flex flex-column justify-content-center">
                          <p className="text-small mb-0">Add Business</p>
                        </Col>
                      </Row>
                    </Card>
                  </Col>
                  {/* Add businesses end */}

                </BetaWrapper>
              </Row>
            </div>
            {/* Quick Add end */}
</Col>
<Col>
            {/* MORE start */}
            <div className='mb-5'>
              <Row>
              <NavLink to="/settings"  onClick={() => setShow(false)}>
                      <Row className="p-2 border-bottom">
                        <Col xs="2" className="d-flex align-items-center justify-content-center">
                          <div className="pe-card">
                            <CsLineIcons icon="gear" className="text-muted" />
                          </div>
                        </Col>
                        <Col xs="10" className="d-flex flex-column justify-content-center">
                          <p className="mb-0 text-body">Settings</p>
                        </Col>
                      </Row>
                    </NavLink>
                    <NavLink to="/contact"  onClick={() => setShow(false)}>
                    <Row className="p-2 border-bottom">
                        <Col xs="2" className="d-flex align-items-center justify-content-center">
                          <div className="pe-card">
                            <CsLineIcons icon="send" className="text-muted" />
                          </div>
                        </Col>
                        <Col xs="10" className="d-flex flex-column justify-content-center">
                          <p className="mb-0 text-body">Contact Us</p>
                        </Col>
                      </Row>
                    </NavLink>
                    <div onClick={() => showSettingsModal()}>
                    <Row className="p-2 border-bottom">
                        <Col xs="2" className="d-flex align-items-center justify-content-center">
                          <div className="pe-card">
                            <CsLineIcons icon="paint-roller" className="text-muted" />
                          </div>
                        </Col>
                        <Col xs="10" className="d-flex flex-column justify-content-center">
                          <p className="mb-0 text-body">Visual Preferences</p>
                        </Col>
                      </Row>
                    </div>
                    <NavLink to="/about-us"  onClick={() => setShow(false)}>
                    <Row className="p-2 border-bottom">
                        <Col xs="2" className="d-flex align-items-center justify-content-center">
                          <div className="pe-card">
                            <CsLineIcons icon="info-hexagon" className="text-muted" />
                          </div>
                        </Col>
                        <Col xs="10" className="d-flex flex-column justify-content-center">
                          <p className="mb-0 text-body">About Us</p>
                        </Col>
                      </Row>
                    </NavLink>
                    <NavLink to="/resources/hello-tiara-faq"  onClick={() => setShow(false)}>
                    <Row className="p-2 border-bottom">
                        <Col xs="2" className="d-flex align-items-center justify-content-center">
                          <div className="pe-card">
                            <CsLineIcons icon="question-hexagon" className="text-muted" />
                          </div>
                        </Col>
                        <Col xs="10" className="d-flex flex-column justify-content-center">
                          <p className="mb-0 text-body">FAQ</p>
                        </Col>
                      </Row>
                    </NavLink>
                    <NavLink to="/terms-and-conditions"  onClick={() => setShow(false)}>
                    <Row className="p-2 border-bottom">
                        <Col xs="2" className="d-flex align-items-center justify-content-center">
                          <div className="pe-card">
                            <CsLineIcons icon="file-text" className="text-muted" />
                          </div>
                        </Col>
                        <Col xs="10" className="d-flex flex-column justify-content-center">
                          <p className="mb-0 text-body">Terms & Conditions</p>
                        </Col>
                      </Row>
                    </NavLink>
                    <NavLink to="/privacy-policy"  onClick={() => setShow(false)}>
                    <Row className="p-2 border-bottom">
                        <Col xs="2" className="d-flex align-items-center justify-content-center">
                          <div className="pe-card">
                            <CsLineIcons icon="file-text" className="text-muted" />
                          </div>
                        </Col>
                        <Col xs="10" className="d-flex flex-column justify-content-center">
                          <p className="mb-0 text-body">Privacy Policy</p>
                        </Col>
                      </Row>
                    </NavLink>
                    {/* <Button onClick={() => {
                userStore.logout()
                history.push('/login')
              }} variant='muted' className='p-2 w-100'>
                      <CsLineIcons icon="logout" className="me-2" size="17" /> <span className="align-middle">Logout</span>
                    </Button> */}
                      <Button onClick={handleLogout} variant='muted' className='p-2 w-100'>
                      <CsLineIcons icon="logout" className="me-2" size="17" /> <span className="align-middle">Logout</span>
                    </Button>
              </Row>
            </div>
            {/* MORE end */}
            <div>
            <Button variant="outline-info" className="btn-icon btn-icon-only m-1" href="https://www.facebook.com/hellotiaraco/" target='_blank'>
                  <CsLineIcons icon="facebook" /> 
                </Button>{' '}
            </div>
</Col>
        </Row>
        <PreferencesModal show={isShowSettingsModal} handleClose={closeSettingsModal} />
      </Modal.Body>
    </Modal>

  );
};

export default UserOptionsModal;
